<div class="row">
  <div class="col-12 col-lg-4 offset-lg-4">
    <h1>Sign In</h1>
    @if (errorMessage) {
      <p class="alert alert-danger">{{errorMessage}}</p>
    }
    @if (!errorMessage) {
      <p>Signing in... please wait.</p>
    }
  </div>
</div>
